/*
 * <promo-disclosure> — kampanya rozeti tıklanınca "kampanyaya dahil ürünler" panelini açar.
 *
 * Markup (product-info.liquid, fiyat bloğu):
 *
 *   <promo-disclosure style="display: contents">
 *     <div class="product-price-row">
 *       <button class="promo-badge promo-badge--toggle" aria-expanded="false" aria-controls="ID">…</button>
 *       <price-list>…</price-list>
 *     </div>
 *     <div id="ID" class="promo-panel" hidden>…</div>
 *   </promo-disclosure>
 *
 * Panel varsayılan KAPALI ve bu dosya yüklenmezse kapalı kalır — aynı ürünler sayfanın
 * altındaki kampanya şeridinde de listelendiği için bilgi kaybı olmaz (aşamalı iyileştirme).
 *
 * Panel `hidden` ile açılıp kapanır, CSS'e bağlı değildir; böylece varyant değişiminde bölüm
 * yeniden çizildiğinde panel kendiliğinden kapalı başlar (istenen davranış: yeni varyantın
 * fiyatı görünsün, panel kullanıcıyı şaşırtacak şekilde açık kalmasın).
 */
(function () {
  if (window.customElements.get('promo-disclosure')) {
    return;
  }

  var PromoDisclosure = class extends HTMLElement {
    connectedCallback() {
      this._onClick = this.onClick.bind(this);
      this._onKeydown = this.onKeydown.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
    }

    get toggle() {
      return this.querySelector('.promo-badge--toggle');
    }

    get panel() {
      var toggle = this.toggle;
      var id = toggle && toggle.getAttribute('aria-controls');
      // Panel bu elemanın İÇİNDE aranır: aynı sayfada birden çok ürün formu olabilir
      // (öne çıkan ürün bölümü), getElementById yanlış paneli yakalayabilirdi.
      return id ? this.querySelector('#' + CSS.escape(id)) : null;
    }

    onClick(event) {
      var toggle = event.target.closest('.promo-badge--toggle');

      if (!toggle || !this.contains(toggle)) {
        return;
      }

      event.preventDefault();
      this.setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    }

    onKeydown(event) {
      if (event.key !== 'Escape') {
        return;
      }

      var toggle = this.toggle;

      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        this.setExpanded(false);
        toggle.focus();
      }
    }

    setExpanded(expanded) {
      var toggle = this.toggle;
      var panel = this.panel;

      if (!toggle || !panel) {
        return;
      }

      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.toggleAttribute('hidden', !expanded);
    }
  };

  window.customElements.define('promo-disclosure', PromoDisclosure);
})();
